export const locale = {
    lang: "pt-BR",
    data: {
        ADD_CREDIT_CARD: {
            TITLE: "Adicionar novo cartão de crédito",
            ADD_BUTTON: "Salvar",
            CANCEL_BUTTON: "Cancelar"
        }
    }
};
